import { compose, mapProps } from 'recompose';
import { connect } from 'dva';
import { Form } from 'antd';
import FormWorkflow from './form_workflow';

export default compose(
  connect(({ loading, errors }) => ({
    submitting: loading.effects['workflows/create'],
    formErrors: errors.formErrors,
  })),
  Form.create(),
  mapProps(ownerProps => ({
    ...ownerProps,
    type: 'new',
  })),
)(FormWorkflow);
